import React, { useEffect, useState } from 'react';
import AOS from 'aos';
import './index.css?v=1.1';

const VisitorCounter = () => {
  const SESSION_KEY = 'sessionTracked';
  const [visitorCount, setVisitorCount] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Function to fetch current visitor count
  const fetchVisitorCount = async () => {
    try {
      const response = await fetch('/api/visitor-count.php');
      const result = await response.json();
      
      if (result.success) {
        return result.data.count;
      } else {
        throw new Error(result.error || 'Failed to fetch visitor count');
      }
    } catch (err) {
      console.error('Error fetching visitor count:', err);
      throw err;
    }
  };

  // Function to increment visitor count
  const incrementVisitorCount = async () => {
    try {
      const response = await fetch('/api/visitor-count.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ increment: true }),
      });
      
      const result = await response.json();
      
      if (result.success) {
        return result.data.count;
      } else {
        throw new Error(result.error || 'Failed to update visitor count');
      }
    } catch (err) {
      console.error('Error updating visitor count:', err);
      throw err;
    }
  };

  useEffect(() => {
    const initializeVisitorCount = async () => {
      try {
        setLoading(true);
        const sessionTracked = sessionStorage.getItem(SESSION_KEY);

        if (!sessionTracked) {
          // New session - increment count
          const newCount = await incrementVisitorCount();
          setVisitorCount(newCount);
          sessionStorage.setItem(SESSION_KEY, 'true');
        } else {
          // Existing session - just fetch current count
          const currentCount = await fetchVisitorCount();
          setVisitorCount(currentCount);
        }
      } catch (err) {
        console.log('API failed, using fallback count for development');
        // Fallback to a default count if API fails (for development)
        setVisitorCount(1247);
        setError(null); // Don't set error so component remains visible
      } finally {
        setLoading(false);
      }
    };

    initializeVisitorCount();
  }, []);

  // Hide component completely if there's an error
  if (error) {
    return null;
  }

  return (
    <div className="visitor-section">
      <div className="visitor-card">
        <div>
          <div className='visitor-wrap'>
            {/* <img src="image/visitor.png" height={"30px"}/> */}
            <div className="pulse-ring"></div>
            <div>
              <h1 className='visitor-title' style={{fontSize:'1.3rem'}}>Number of visitors visited this website {loading ? (
            <span>Loading...</span>
          ) : (
            <span  style={{ color: '#317bb7' , fontWeight: 900, fontSize: '1.3rem', marginBottom:0  }}>{visitorCount.toLocaleString()}</span>
          )}</h1>
            </div>
          </div>
        </div>
       
      </div>
    </div>
  );
};

export default VisitorCounter;
